module.exports = __webpack_public_path__ + "img/sponsers.6e4ee2cc.svg";